<template>
  <div>
    <div class="grid ver-padding-40">
      <h1 class="r-margin-30">Добавить процессинг</h1>
    </div>

    <div>
      <form @submit.prevent="onSubmit" @keypress.enter="pressEnter" class="grid">
        <div class="u-16 page-block grid controls-inline">
          <!-- active -->
          <div class="r-margin-20">
            <AppCheckbox v-model="form.active" id="option-active">Активен</AppCheckbox>
          </div>
          <div class="r-margin-20">
            <AppCheckbox v-model="form.is_test" id="option-istest">Тестовый</AppCheckbox>
          </div>
        </div>

        <div class="page-block u-16 grid cross-center between">
          <!-- name -->
          <div class="u-16 u-8-ls r-padding-0 r-padding-10-ls">
            <AppInput
              v-model.trim="form.name"
              label="Название"
              size="medium"
              required
              @blur="validateName(form.name, true)"
              @input="validateName(form.name, false)"
            ></AppInput>
          </div>
          <!-- human_name -->
          <div class="u-16 u-8-ls ver-margin-20 ver-margin-0-ls l-padding-0 l-padding-10-ls">
            <AppInput
              v-model.trim="form.human_name"
              label="Название 2 (human_name)"
              size="medium"
              required
              @blur="validateHumanName(form.human_name, true)"
              @input="validateHumanName(form.human_name, false)"
            ></AppInput>
          </div>
          <div class="u-16 ver-margin-0 ver-margin-10-ls"></div>
          <!-- currency_code -->
          <div class="u-16 u-8-ls grid ver-margin-20 ver-margin-0-ls">
            <div class="u-16 u-8-ls map-input">
              <label>
                Валюта
                <span class="map-label--required">*</span>
              </label>
              <el-select v-model="form.currency_code" filterable placeholder size="large">
                <el-option
                  v-for="item in currencyList"
                  :key="item.currency_id"
                  :label="'[' + item.currency_id + '] ' + item.currency_name_ru"
                  :value="item.currency_id"
                >
                  <span>[{{ item.currency_id }}] {{ item.currency_name_ru }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="u-16 u-0-ls ver-margin-10 ver-margin-0-ls"></div>
          </div>
        </div>

        <div class="page-block u-16 grid cross-center between">
          <el-tabs v-model="activeName" class="u-16">
            <el-tab-pane
              v-for="(item, key) in form.configuration"
              :key="key"
              :label="key"
              :name="key"
            >
              <div class="u-16 grid">
                <div class="u-16 ver-margin-5"></div>
                <div
                  v-for="(obj, index) in item"
                  :key="index"
                  class="u-16 grid ver-margin-5 grid cross-center"
                >
                  <div class="u-16" v-if="index=='scheme'">
                    <label>{{index}}</label>
                    <el-select v-model="item[index]" filterable placeholder size="large">
                      <el-option
                        v-for="(item, index) in schemeOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>

                  <div class="u-16" v-else>
                    <AppInput
                      v-model.trim="item[index]"
                      :label="index"
                      size="medium"
                      :type="index == 'timeout' ? 'number' : 'text'"
                      :min="index == 'timeout' ? 0 : null"
                    ></AppInput>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- submit -->
        <div class="u-16 ver-margin-20">
          <AppButton class="r-margin-20" :disabled="disableButton">Добавить</AppButton>
          <AppButton type="border" @click.prevent="cancel">Отменить</AppButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
import errors from "@/localize/errors.js";
Vue.use(VueAxios, axios);

export default {
  name: "AddProcessing",
  data() {
    return {
      loading: false,
      activeName: "general",
      schemeOptions: [
        { value: "http", label: "http" },
        { value: "https", label: "https" }
      ],
      form: {
        active: false,
        is_test: false,
        name: "",
        human_name: "",
        currency_code: 643,
        configuration: {
          general: {
            timeout: "0"
          },
          endpoint: {
            scheme: "http",
            hostname: "",
            port: "",
            api_path: "",
            username: "",
            password: ""
          },
          bo: {
            icon_url: ""
          },
          moneywall: {
            token: "",
            callback_url: ""
          },
          kkb: {
            private_key: "",
            public_key: "",
            cert_id: ""
          }
        }
      },
      validateStack: {
        name: false,
        human_name: false
      },
      is_disabled: true
    };
  },
  methods: {
    onSubmit() {
      let req = { ...this.form };
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      if (req.configuration.general.timeout)
        req.configuration.general.timeout = parseInt(
          req.configuration.general.timeout
        );
      axios
        .post(
          apiUrl + "processing/create",
          _.omit(req, i => !i),
          config
        )
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.showError("Процессинг успешно добавлен", "success");
            this.cancel();
          } else {
            if (errors.message.hasOwnProperty(data.message))
              this.showError(errors.message[data.message]);
            else this.showError(errors.message["default"]);
            return false;
          }
        })
        .catch(err => {
          console.log(err.response.data.message);
          if (err.response)
            this.showError(errors.message[err.response.data.message]);
        });
    },
    cancel() {
      this.$router.push({
        name: "s_Processings"
      });
    },
    pressEnter(e) {
      e.preventDefault();
    },
    validateName(name, is_shown_message) {
      if (name) {
        let re = /^[a-zA-Z][a-zA-Z0-9-_.]{2,20}$/;
        setTimeout(() => {
          if (!re.test(name)) {
            if (is_shown_message)
              this.showError(
                "Название должно состоять из латинских символов и цифр, без пробелов"
              );
            this.validateStack.name = false;
            return false;
          } else {
            this.validateStack.name = true;
            return true;
          }
        }, 300);
      } else {
        if (is_shown_message) this.showError("Введите название");
        this.validateStack.name = false;
        return false;
      }
    },
    validateHumanName(human_name, is_shown_message) {
      if (human_name) {
        let re = /^[а-яёА-ЯЁa-zA-Z0-9\s()-_.]{2,32}$/;
        setTimeout(() => {
          if (!re.test(human_name)) {
            if (is_shown_message)
              this.showError(
                "Название может состоять из цифр, латинских и кириллических символов. Допускаются (), _ , —"
              );
            this.validateStack.human_name = false;
            return false;
          } else {
            this.validateStack.human_name = true;
            return true;
          }
        }, 300);
      } else {
        if (is_shown_message) this.showError("Введите название");
        this.validateStack.human_name = false;
        return false;
      }
    },
    showError(text, type) {
      type = type ? type : "error";
      this.$message({
        showClose: true,
        message: text,
        type: type,
        duration: 3000
      });
    }
  },
  created() {},
  computed: {
    ...mapGetters(["processingName", "currencyCharacter", "currencyList"]),
    disableButton() {
      let count = 0;
      for (let key in this.validateStack) {
        if (this.validateStack[key]) count++;
        else count = 0;
      }
      return count == 0;
    }
  }
};
</script>
